import React, { createContext, useContext, useMemo } from 'react'
import PropTypes from 'prop-types'

const EducatorProfileContext = createContext({})

export const PreferenceTypes = {
  STUDENT_ACTIVITIES: 'StudentActivities',
  EDUCATOR_PRACTICES: 'EducatorPractices',
  SCHOOLWIDE_PRACTICES: 'SchoolwidePractices',
}

const ADMIN_LABEL = 'admin'

export function EducatorProfileCheckerProvider(props) {
  const { currentSite, children } = props
  const contextValue = useMemo(() => ({ currentSite }), [currentSite])

  return (
    <EducatorProfileContext.Provider value={contextValue}>
      {children}
    </EducatorProfileContext.Provider>
  )
}

EducatorProfileCheckerProvider.propTypes = {
  children: PropTypes.node.isRequired,
  currentSite: PropTypes.shape({
    highSchoolSitePreferences: PropTypes.object,
    highSchoolEducatorPreferences: PropTypes.object,
    claims: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
}

export function useEducatorPreferences() {
  const { currentSite } = useContext(EducatorProfileContext) || {}

  // Ensure all destructured values have fallback values to prevent undefined errors
  const highSchoolSitePreferences = currentSite?.highSchoolSitePreferences || {}
  const highSchoolEducatorPreferences =
    currentSite?.highSchoolEducatorPreferences || {}
  const claims = currentSite?.claims || []

  // Check if we should show all learning experiences
  const shouldShowAllLearningExperiences =
    !highSchoolEducatorPreferences?.teachesStudentActivities &&
    !highSchoolEducatorPreferences?.teachesEducatorActivities &&
    !highSchoolEducatorPreferences?.teachesSchoolwideActivities

  function checkEducatorPreferences(preference) {
    if (shouldShowAllLearningExperiences) {
      return true
    }

    switch (preference) {
      case PreferenceTypes.STUDENT_ACTIVITIES:
        return (
          highSchoolSitePreferences?.studentActivities &&
          highSchoolEducatorPreferences?.teachesStudentActivities
        )
      case PreferenceTypes.EDUCATOR_PRACTICES:
        return !!highSchoolEducatorPreferences?.teachesEducatorActivities
      case PreferenceTypes.SCHOOLWIDE_PRACTICES:
        const isAdmin = claims?.some(
          claim =>
            claim?.toLowerCase &&
            claim?.toLowerCase() === ADMIN_LABEL?.toLowerCase(),
        )
        return (
          isAdmin &&
          !!highSchoolEducatorPreferences?.teachesSchoolwideActivities
        )
      default:
        return false
    }
  }

  return {
    checkEducatorPreferences,
    currentSite,
  }
}
